import React, { useState, useEffect } from "react";
import { message, Upload, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import "./sendV2.scss";
import { getAccessTokenApi,getRefreshTokenApi, getPublicIP,getKeyrockTokenApi } from "../../api/auth";
import { basePath, apiVersion } from "../../api/config";
import { post } from "../../api/post";
import {
  ArrowRightOutlined,ArrowLeftOutlined,CloudDownloadOutlined,SaveOutlined
} from "@ant-design/icons";
import SliderFilter from "../Admin/Graphs/Slider/Slider"
import {getContarError,getExcel} from "../../api/user";
import MapPoly from "../Admin/MapPoly/MapPoly"
import MapAddOrders from "../Admin/MapAddOrders/MapAddOrders"
import DemoPie from "../Admin/Graphs/Pie/Pie"


export default function Send() {
  
  const [range, setrange] = useState([10,10,10,10,10,10,10,10,10,10,10]);
  const [top, settop] = useState([50,50,50,50,50,50,50,50,50,50,50]);
  const [bottom, setbottom] = useState([0,0,0,0,0,0,0,0,0,0,0]);
  const [stepG, setstepG] = useState([1,1,1,1,1,1,1,1,1,1,1]);
  const [inputValue1, setInputValue1] = useState(
    [0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    ]
  );
  const [inputValue2, setInputValue2] = useState(
    [10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    ]
  );
  const [value5, setValue5] = useState(
    [50,
    50,
    50,
    50,
    50,
    ]
  );
  const [inputValue3, setInputValue3] = useState([0,0,0,0,0,0,0,0,0,0,0]);
  const [disabled, setDisabled] = useState([false,false,false,false,false,false,false,false,false,false,false]);
  const [aux, setAux] = useState(true);//no vale nada, solo actualiza el estado, cuando utilzas una variable como vector, no la actualiza de manera instantanea
  const [checkboxtotState, setCheckboxtotState] = useState({
    checkboxtot0: false,
    checkboxtot1: false,
    checkboxtot2: false,
    checkboxtot3: false,
    checkboxtot4: false,
    checkboxtot5: false,
    checkboxtot6: false,
    checkboxtot7: false,
    checkboxtot8: false,
    checkboxtot9: false,
    checkboxtot10: false,
  });

  var data = [
    {
      type: "Distance",
      // type: "Geo-Distribution",
      // type: "Profitability",
      value: Math.round(100*(value5[0])/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Time",
      // type: "Systemic Viability",
      // type: "Productivity",
      value: Math.round(100*value5[1]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Emissions",
      // type: "Economic Nature",
      // type: "Systemic Viability",
      value: Math.round(100*value5[2]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "% Orders Completed",
      // type: "Channel Capillarity",
      // type: "Safety",
      value: Math.round(100*value5[3]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Veh. Filling",
      // type: "Operational Compatibility",
      // type: "Working Conditions",
      value: Math.round(100*value5[4]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
  ];
  
  const onChange = ([newvalue,newValues]) => {
    /* setInputValue1(newvalue);
    setInputValue2(newValues); */
  };
  

  const checkgeneral = (e) => {
    var newCheckboxtotState = checkboxtotState;
    newCheckboxtotState[e.target.value] = e.target.checked;
     setAux(!aux)
     setCheckboxtotState(newCheckboxtotState);
  }

  const [checkboxState, setCheckboxState] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false, 
    checkbox5: false,
  });

  const handleCheckboxChange = (e) => {
    const newCheckboxState = {
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
    };
    newCheckboxState[e.target.value] = e.target.checked;
    setCheckboxState(newCheckboxState);
  };

  const [value1, setValue1] = useState();
  // const onChangeFilter1 = (newValue) => {
  //   setValue1(newValue);
  // };

  // const [value2, setValue2] = useState();
  // const onChangeFilter2 = (newValue) => {
  //   setValue2(newValue);
  // };


  const style = {
    display: 'flex',
    flexDirection:'column',
    width: 300,
  };

  const style1 = {
    display: 'flex',
    flexDirection:'column',
    width: 500,
    marginRight:'50px'
  };
  
  const [circular, setCircular] = useState(false);
  const [page, setPage] = useState(0);
  const [disable, setDisable] = useState(true);
  const [name, setName] = useState('');
  const { Dragger } = Upload;

  const props_full = {
    name: "file",
    multiple: false,
    action: `${basePath}/${apiVersion}/subir-file-pre`,
    headers: {
      Authorization: "Bearer " + getAccessTokenApi(),
      refreshToken: "Bearer " + getRefreshTokenApi(),
      functionname:'uploadExcel',
      keyrockAuth: getKeyrockTokenApi(),
      ippublica:getPublicIP()
    },
    onChange(info) {
      const { status } = info.file;
      // console.log('status: ',status)
      // console.log('info.file: ',info.file)
      if (status !== "uploading") {
      // console.log('info.file.xhr.response: ',info.file.xhr.response)
      // console.log('info.file.response: ',info.file.response)
      setName(JSON.parse(info.file.xhr.response).message);
      setDisable(false)
      }
      if (status === "done") {
        // message.ss(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        console.log('info.file.response: ',info.file.response)
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
    },
    // beforeUpload: (file) => {
    //   return true;
    // },
    beforeUpload: (file) => {
      const fileSize = file.size / 1024 / 1024; // Convert file size to MB
      // console.log('tamaño cosas MB: ',fileSize)
      if (fileSize > 10) {
        message.error('File size should be less than 1MB.');
        return false;
      }
      return true;
    }
  };

  const props = {
    name: "file",
    multiple: false,
    action: `${basePath}/${apiVersion}/orders-database`,
    headers: {
      Authorization: "Bearer " + getAccessTokenApi(),
      refreshToken: "Bearer " + getRefreshTokenApi(),
      functionname:'uploadOrders',
      keyrockAuth: getKeyrockTokenApi(),
      ippublica:getPublicIP()
    },
    onChange(info) {
      const { status } = info.file;
      console.log('status: ',status)
      console.log('info.file: ',info.file)
      if (status !== "uploading") {
        // setName(JSON.parse(info.file.xhr.response).message);
        // setDisable(false)
      }
      if (status === "done") {
        setName(JSON.parse(info.file.xhr.response).message);
        setDisable(false)
        // message.ss(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        console.log('info.file.response: ',info.file.response)
        if(info.file.response.error==='hubs'){
          // notification["error"]({
          //   message: `You must add your own hubs to upload this file.`,
          // });
          message.error(`You must add your own hubs to upload this file.`);
        }else if(info.file.response.error==='vehicles'){
          // notification["error"]({
          //   message: `You must add your own vehicles to upload this file.`
          // });
          message.error(`You must add your own vehicles to upload this file.`);
        }else if(info.file.response.error==='hubvehicles'){
          // notification["error"]({
          //   message: `You must add your own vehicles to upload this file.`
          // });
          message.error(`Your hubs must have assigned at least one vehicle to upload this file.`);
        }
        // console.log('info')
        // console.log(info)
        // console.log(info.file.response.error)
        // console.log('info')
      }
    },
    onDrop(e) {
    },
    // beforeUpload: (file) => {
    //   return true;
    // },
    beforeUpload: (file) => {
      const fileSize = file.size / 1024 / 1024; // Convert file size to MB
      console.log('tamaño cosas MB: ',fileSize)
      if (fileSize > 10) {
        message.error('File size should be less than 1MB.');
        return false;
      }
      return true;
    }
  };


  async function filtrar(){

    // if(sheetName===treeData[0].title){
    //   (filter===treeData[0].children[0].title)
    //   ?leter = 'I'
    //   :(filter===treeData[0].children[1].title)
    //   ?leter = 'Q'
    //   :leter = '0'
    // }else if(sheetName===treeData[1].title){
    //   (filter===treeData[1].children[0].title)
    //   ?leter = 'F'
    //   :(filter===treeData[1].children[1].title)
    //   ?leter = 'G'
    //   :leter = '0'
    // }else if(sheetName===treeData[2].title){
    //   (filter===treeData[2].children[0].title)
    //   ?leter = 'D'
    //   :(filter===treeData[2].children[1].title)
    //   ?leter = 'E'
    //   :(filter===treeData[2].children[2].title)
    //   ?leter = 'F'
    //   :leter = '0'
    // }else if(sheetName===treeData[3].title){
    //   (filter===treeData[3].children[0].title)
    //   ?leter = 'D'
    //   :leter = '0'
    // }
    var vectorCheck=[]
    for (var i =0;i<11;i++){
      if(checkboxtotState[`checkboxtot${i}`])
      vectorCheck=[...vectorCheck,i]
    }

    for (var j =0;j<vectorCheck.length;j++){
      var url;
      (!disabled[vectorCheck[j]])
      ? url =  `${basePath}/${apiVersion}/simulate-all`
      :url =  `${basePath}/${apiVersion}/simulate-all-add`;
      const bottomm = inputValue1[vectorCheck[j]];
      const topp = inputValue2[vectorCheck[j]];
      const step = stepG[vectorCheck[j]];
      const add = inputValue3[vectorCheck[j]];
      var status;
      var urlFetch='';
      var messag=''; 

      //const aux = String(value1).split('-')
      var sheetName;//la sheet a editar
      var filter; //treeData[aux[1]].children[aux[2]-1].title;//solo sirve para añadir al nombre del xlsx 
      var leter; //la columna que quieres editar... en esta caso early time
      
      if(vectorCheck[j]===0){
        leter = 'I'
        sheetName='IN1_Orders'
        filter='order_servicetime1'
      }else if(vectorCheck[j]===1){
        leter = 'Q';
        sheetName='IN1_Orders';
        filter='order_servicetime2'
      }else if(vectorCheck[j]===2){
        leter = 'J';
        sheetName='IN1_Orders';
        filter='order_items'
      }else if(vectorCheck[j]===3){
        leter = 'K';
        sheetName='IN1_Orders';
        filter='order_weight'
      }else if(vectorCheck[j]===4){
        leter = 'D';
        sheetName='IN3_TranspTypes';
        filter='transptype_capacityitems'
      }else if(vectorCheck[j]===5){
        leter = 'E';
        sheetName='IN3_TranspTypes';
        filter='transptype_capacityweight'
      }else if(vectorCheck[j]===6){
        leter = 'F';
        sheetName='IN3_TranspTypes';
        filter='transptype_speed'
      }else if(vectorCheck[j]===7){
        leter = 'H';
        sheetName='IN3_TranspTypes';
        filter='transptype_kmcost'
      }else if(vectorCheck[j]===8){
        leter = 'I';
        sheetName='IN3_TranspTypes';
        filter='transptype_hourcost'
      }else if(vectorCheck[j]===9){
        leter = 'J';
        sheetName='IN3_TranspTypes';
        filter='transptype_co2emissions'
      }else if(vectorCheck[j]===10){
        leter = 'D';
        sheetName='IN4_Transp';
        filter='transp_num'
      }else{
        leter = 'I';
        sheetName='IN4_Transp';
        filter='example'
      }


      var datos; 
      (!disabled[vectorCheck[j]])
      ?datos = {
        name:name,
        bottom: bottomm,
        top:topp,
        step :step,
        filter:filter,
        sheetName:sheetName,
        leter:leter
      }
      :datos = {
        name:name,
        add:add, 
        filter:filter,
        sheetName:sheetName,
        leter:leter
      }

      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessTokenApi(),
          refreshToken: "Bearer " + getRefreshTokenApi(),
          functionname:name,
          ippublica:getPublicIP()
        },
        body: JSON.stringify(datos),
      };
      await fetch(url, params)
        .then((response) => {
          status=response.status;
          urlFetch=response.url;
          urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
          return response.json();
        })
        .then((result) => {
          if(status!==200){
            messag=result.message
            notification["error"]({
              message: `Error ${status} in function: ${urlFetch}`,
              description:messag
            });
            getContarError(urlFetch,messag);
          }else{
            //setCircular(false)
            notification["success"]({
              message: `Changes Saved!`,
              description:'Click "Back" to continue the simulation.'
            });
          }
           return result;
        })
        .catch((err) => {
           return err.message;
        });
        
    }
  }
  
  if(page===0){
    return (
      <div>
        {/* <h1 style={{
            fontFamily:'report-bold',
            fontSize:'18px',}}>
          If you have a complete excel, drag it into the "Drag and Drop" area and clic the "NEXT" buttom. Unless select "Build the Simulation".
        </h1> */}
        <p></p>
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <Row justify='center'>
            <Col>
              <p style={{
                fontFamily:'report',
                fontSize:'18px',}} className="ant-upload-text">
                Click or drag file to this area to upload the data &nbsp;
              </p>
            </Col>
            <Col>
              <p style={{
                fontFamily:'report-bold',
                fontSize:'17px',}} className="ant-upload-text">
                WITH YOUR OWN HUBS AND VEHICLES
              </p>
            </Col>
          </Row>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-text">
            then click NEXT
          </p>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading
            company data or other band files
          </p>
        </Dragger>
        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
          <div className="RowMiddle">
            <Button className="boton"
                disabled={/* disable */false}
                style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                marginTop:'20px',
                color:'rgb(0,104,178)',
                marginRight:'50px',
                backgroundColor: "white" }}
                type="primary"
                onClick={ () => {
                  getExcel(true,false,false,false)
                  }}>
                Download an example simulation excel
                <CloudDownloadOutlined />
              </Button>
              <Button className="boton"
              style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                color:'rgb(0,104,178)',
                marginTop:'20px',
                backgroundColor: "white" }}
                disabled={/* disable */false}
                
                type="primary"
                onClick={ () => {
                  getExcel(false,false,false,false)
                  }}>
                Download base excel
                <CloudDownloadOutlined />
              </Button>
            </div>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            marginTop:'20px',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
             
              if(name.length>2){
                setPage(1)
              }else{
                notification["error"]({
                  message: `Upload an Excel`,
                  description:'Upload an excel to cotinue the simulation'
                });
              }
             
              }}>
            Next
            <ArrowRightOutlined />
          </Button>
          </div>
          <p></p>
          <Dragger {...props_full}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <Row justify='center'>
            <Col>
              <p style={{
                fontFamily:'report',
                fontSize:'18px',}} className="ant-upload-text">
                Click or drag file to this area to upload a &nbsp;
              </p>
            </Col>
            <Col>
              <p style={{
                fontFamily:'report-bold',
                fontSize:'17px',}} className="ant-upload-text">
                FULL EXCEL
              </p>
            </Col>
          </Row>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading
            company data or other band files
          </p>
        </Dragger>
        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
          <div className="RowMiddle">
            <Button className="boton"
                disabled={/* disable */false}
                style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                marginTop:'20px',
                color:'rgb(0,104,178)',
                marginRight:'50px',
                backgroundColor: "white" }}
                type="primary"
                onClick={ () => {
                  getExcel(true,true,false,false)
                  }}>
                Download an example simulation excel
                <CloudDownloadOutlined />
              </Button>
              <Button className="boton"
              style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                color:'rgb(0,104,178)',
                marginTop:'20px',
                backgroundColor: "white" }}
                disabled={/* disable */false}
                
                type="primary"
                onClick={ () => {
                  getExcel(false,true,false,false)
                  }}>
                Download base excel
                <CloudDownloadOutlined />
              </Button>
            </div>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            marginTop:'20px',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
             
              window.location.href = `/admin/output`;
             
              }}>
            Go to Outputs
            <ArrowRightOutlined />
          </Button>
          </div>
          {/* <div className="sendV2" onClick={()=>setPage(9)}>
              <div style={{
                margin:'10px',
                height:'100%',width:'100%',
                }}>
                <div style={{
                  display:'flex',
                  fontFamily:'report-bold',
                  fontSize:'25px',
                  flexDirection:'row',
                  justifyContent:'center',}}>
                  <h1>Build the Simulation</h1>
                  </div>
                <div style={{
                  display:'flex',
                  fontFamily:'report',
                  fontSize:'18px',
                  flexDirection:'row',
                  justifyContent:'center',}}>
                  <h1>Make your simulation from the beginning</h1>
                  </div>
                <div style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'center',}}>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Upload all your orders</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Select the orders that you want to simulate</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Add your hubs in the map</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Add your vehicles</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Choose if you want to do a parametric simulation or add other properties</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Choose if you want to do a parametric simulation or add other properties</h1>
                    </div>
                    <div className="send-sep">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Run simulation</h1>
                    </div>
                </div>
              </div>
          </div> */}
          
      </div>
    );
  } else if (page===1){

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Simulation name: {name}</h2>
        <h2 style={{ fontFamily:'report',
            fontSize:'20px',}}>Choose the wanted orders and save changes before click the next buttom, or click the next buttom if you want to simulate all the orders.</h2>
        <MapPoly nombre={name}></MapPoly>
        <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(0);setName('')}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(3)}}>
            Next
              <ArrowRightOutlined />
            
          </Button>
          </div>
      </div>
    );
  } else if (page===2){

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Simulation name: {name}</h2>
        <h2 style={{ fontFamily:'report',
            fontSize:'20px',}}>Add the wanted orders and save changes before click the next buttom, or click the next buttom if you want to simulate just the orders shown.</h2>
        <MapAddOrders nombre={name}></MapAddOrders>
        <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(1);}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(3)}}>
            Next
              <ArrowRightOutlined />
            
          </Button>
          </div>
      </div>
    );
  } else if (page===3){
    return (
      <div>
        <div style={{
                display:'flex', 
                flexDirection: "column" }}>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Simulation: {name}</h2>
        <p></p>
          <div className="heich" style={{
                display:'flex', 
                flexDirection: "column" }}>
            <Checkbox 
              style={{
                fontFamily:'report',
                fontSize:'30px', 
                marginBottom: "10px" ,
                fontWeight:'bold'}}
               value='checkbox1'
              checked={checkboxState.checkbox1}
              onChange={handleCheckboxChange}
            >Simple Simulation</Checkbox>
            <p></p>
            <Checkbox 
              style={{
                fontFamily:'report',
                fontSize:'30px', 
                marginBottom: "10px" ,
                fontWeight:'bold'}}
               value='checkbox2'
              checked={checkboxState.checkbox2}
              onChange={handleCheckboxChange}
            >Multiple Simulation</Checkbox>
            
            </div>
            <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            fontSize:'18px',
            color:'rgb(0,104,178)',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
                setPage(1)
              }}>
            <ArrowLeftOutlined />
            Back
          </Button>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
              const newCheckboxState = {
                checkbox1: false,
                checkbox2: false,
                checkbox3: false,
                checkbox4: false,
                checkbox5: false,
              };
              setCheckboxState(newCheckboxState);
                if(checkboxState.checkbox1) window.location.href = `/admin/output`;
                else if(checkboxState.checkbox2)setPage(4)
                else{
                  notification["error"]({
                    message: `Choose one option`,
                    description:'Choose one option to follow the simulation'
                  });
                }
                
             
              }}>
            {(checkboxState.checkbox1)?'Simulate':'Next'}
            <ArrowRightOutlined />
          </Button>
          </div>
        </div>
       
      </div>
    );
  } else if (page===4){
    return (
      <div>
        <div style={{
                display:'flex', 
                flexDirection: "column" }}>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Simulation: {name}</h2>
        <p></p>
          <div className="heich" style={{
                display:'flex', 
                flexDirection: "column" }}>
            <Checkbox 
              style={{
                fontFamily:'report',
                fontSize:'30px', 
                marginBottom: "10px" ,
                fontWeight:'bold'}}
               value='checkbox1'
              checked={checkboxState.checkbox1}
              onChange={handleCheckboxChange}
            >Parametric Scanning</Checkbox>
            <p></p>
            <Checkbox 
              style={{
                fontSize:'30px', 
                fontFamily:'report',
                marginBottom: "10px" ,
                fontWeight:'bold'}}
               value='checkbox2'
              checked={checkboxState.checkbox2}
              onChange={handleCheckboxChange}
            >Choose weights to compare simulations</Checkbox>
            <p></p>
            <Checkbox 
              style={{
                fontFamily:'report',
                fontSize:'30px', 
                
                marginBottom: "10px" ,
                fontWeight:'bold'}}
               value='checkbox3'
              checked={checkboxState.checkbox3}
              onChange={handleCheckboxChange}
            >Find Hubs</Checkbox>
            </div>
            <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
            <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
                setPage(3)
              }}>
            <ArrowLeftOutlined />
            Back
          </Button>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            fontSize:'18px',
            color:'rgb(0,104,178)',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
              const newCheckboxState = {
                checkbox1: false,
                checkbox2: false,
                checkbox3: false,
                checkbox4: false,
                checkbox5: false,
              };
              setCheckboxState(newCheckboxState);
                if(checkboxState.checkbox1)setPage(5)
                else if(checkboxState.checkbox2)setPage(6)
                else if(checkboxState.checkbox3)setPage(7)
                else{
                  notification["error"]({
                    message: `Choose one option`,
                    description:'Choose one option to follow the simulation'
                  });
                }
                
              }}>
            Next
            <ArrowRightOutlined />
          </Button>
          </div>
          <p></p>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            fontSize:'18px',
            color:'rgb(0,104,178)',
            backgroundColor: "white" }}
            type="primary"
            onClick={ async () => {
              setCircular(true)
              await new Promise((resolve) => setTimeout(resolve, 3000));
              setCircular(false)
              notification["success"]({
                message: `Simulate Completed!`,
                description:'Redirecting to Outputs screen.'
              });
              await new Promise((resolve) => setTimeout(resolve, 2000));
              window.location.href = `/admin/output`;
              }}>
            Simulate All
            <ArrowRightOutlined />
          </Button>
          {(circular)
          ?<div style={{display:'flex',justifyContent:'center'}}>
            <div>
            </div>
            <div className="cargandos">
            </div>
            <div>
            </div>
          </div>
          :<div className="vacio">
            </div>}
        </div>
       
      </div>
    );
  } else if (page===5){

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}} > Simulation: {name}</h2>
        <p></p>
        {/* <h1>Filtro de:</h1>
        <TreeSelect
            style={{
              width: '100%',
            }}
            value={value1}
            dropdownStyle={{
              maxHeight: 300,
              overflow: 'scroll ',
            }}
            treeData={treeData}
            placeholder="Please select"
            treeDefaultExpandAll
            onChange={onChangeFilter1}
          /> */}
          <Divider style={{
            fontFamily:'report',
            fontSize:'18px',}}>FILTERING ORDERS DATA</Divider>
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot0'
                checked={checkboxtotState.checkboxtot0}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: servicetime1</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
                min={bottom[0]}
                disabled={!checkboxtotState.checkboxtot0||disabled[0]} 
                max={inputValue2[0]}
                step={stepG[0]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[0]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[0]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[0]-newValue>range[0]){
                    var auxiliares=inputValue2
                    auxiliares[0]=inputValue2[0]-stepG[0]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[0], inputValue2[0]]} 
              step={stepG[0]}
              min={bottom[0]}
              max={top[0]}
              disabled={!checkboxtotState.checkboxtot0||disabled[0]} 
              onChange={onChange}
              value={[inputValue1[0], inputValue2[0]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
                disabled={!checkboxtotState.checkboxtot0||disabled[0]} 
                min={inputValue1[0]}
                max={top[0]}
                step={stepG[0]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[0]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[0]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[0]>range[0]){
                    var auxiliares=inputValue1
                    auxiliares[0]=inputValue1[0]+stepG[0]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[0]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[0]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot0||!disabled[0]} 
                min={bottom[0]}
                max={top[0]}
                step={stepG[0]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[0]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[0]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[0]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[0]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[0]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[0]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[0]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[0]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[0]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[0]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot1'
                checked={checkboxtotState.checkboxtot1}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: servicetime2</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot1||disabled[1]} 
                min={bottom[1]}
                max={inputValue2[1]}
                step={stepG[1]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[1]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[1]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[1]-newValue>range[1]){
                    var auxiliares=inputValue2
                    auxiliares[1]=inputValue2[1]-stepG[1]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[1], inputValue2[1]]} 
              step={stepG[1]}
              min={bottom[1]}
              max={top[1]}
              disabled={!checkboxtotState.checkboxtot1||disabled[1]} 
              onChange={onChange}
              value={[inputValue1[1], inputValue2[1]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot1||disabled[1]} 
                min={inputValue1[1]}
                max={top[1]}
                step={stepG[1]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[1]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[1]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[1]>range[1]){
                    var auxiliares=inputValue1
                    auxiliares[1]=inputValue1[1]+stepG[1]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[1]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[1]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot1||!disabled[1]} 
                min={bottom[1]}
                max={top[1]}
                step={stepG[1]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[1]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[1]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[1]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[1]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[1]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[1]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[1]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[1]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[1]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[1]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot2'
                checked={checkboxtotState.checkboxtot2}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: items</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot2||disabled[2]} 
                min={bottom[2]}
                max={inputValue2[2]}
                step={stepG[2]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[2]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[2]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[2]-newValue>range[2]){
                    var auxiliares=inputValue2
                    auxiliares[2]=inputValue2[2]-stepG[2]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[2], inputValue2[2]]} 
              step={stepG[2]}
              min={bottom[2]}
              max={top[2]}
              disabled={!checkboxtotState.checkboxtot2||disabled[2]} 
              onChange={onChange}
              value={[inputValue1[2], inputValue2[2]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot2||disabled[2]} 
                min={inputValue1[2]}
                max={top[2]}
                step={stepG[2]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[2]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[2]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[2]>range[2]){
                    var auxiliares=inputValue1
                    auxiliares[2]=inputValue1[2]+stepG[2]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[2]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[2]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot2||!disabled[2]} 
                min={bottom[2]}
                max={top[2]}
                step={stepG[2]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[2]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[2]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[2]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[2]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[2]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[2]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[2]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[2]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[2]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[2]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot3'
                checked={checkboxtotState.checkboxtot3}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: weight</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot3||disabled[3]} 
                min={bottom[3]}
                max={inputValue2[3]}
                step={stepG[3]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[3]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[3]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[3]-newValue>range[3]){
                    var auxiliares=inputValue2
                    auxiliares[3]=inputValue2[3]-stepG[3]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[3], inputValue2[3]]} 
              step={stepG[3]}
              min={bottom[3]}
              max={top[3]}
              disabled={!checkboxtotState.checkboxtot3||disabled[3]} 
              onChange={onChange}
              value={[inputValue1[3], inputValue2[3]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot3||disabled[3]} 
                min={inputValue1[3]}
                max={top[3]}
                step={stepG[3]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[3]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[3]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[3]>range[3]){
                    var auxiliares=inputValue1
                    auxiliares[3]=inputValue1[3]+stepG[3]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[3]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[3]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot3||!disabled[3]} 
                min={bottom[3]}
                max={top[3]}
                step={stepG[3]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[3]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[3]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[3]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[3]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[3]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[3]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[3]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[3]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[3]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[3]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider style={{
            fontFamily:'report',
            fontSize:'18px',}}>FILTERING TRANSPTYPES DATA</Divider>
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot4'
                checked={checkboxtotState.checkboxtot4}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: capacityitems</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot4||disabled[4]} 
                min={bottom[4]}
                max={inputValue2[4]}
                step={stepG[4]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[4]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[4]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[4]-newValue>range[4]){
                    var auxiliares=inputValue2
                    auxiliares[4]=inputValue2[4]-stepG[4]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[4], inputValue2[4]]} 
              step={stepG[4]}
              min={bottom[4]}
              max={top[4]}
              disabled={!checkboxtotState.checkboxtot4||disabled[4]} 
              onChange={onChange}
              value={[inputValue1[4], inputValue2[4]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot4||disabled[4]} 
                min={inputValue1[4]}
                max={top[4]}
                step={stepG[4]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[4]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[4]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[4]>range[4]){
                    var auxiliares=inputValue1
                    auxiliares[4]=inputValue1[4]+stepG[4]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[4]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[4]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot4||!disabled[4]} 
                min={bottom[4]}
                max={top[4]}
                step={stepG[4]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[4]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[4]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[4]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[4]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[4]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[4]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[4]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[4]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[4]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[4]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot5'
                checked={checkboxtotState.checkboxtot5}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: capacityweight</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot5||disabled[5]} 
                min={bottom[5]}
                max={inputValue2[5]}
                step={stepG[5]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[5]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[5]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[5]-newValue>range[5]){
                    var auxiliares=inputValue2
                    auxiliares[5]=inputValue2[5]-stepG[5]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[5], inputValue2[5]]} 
              step={stepG[5]}
              min={bottom[5]}
              max={top[5]}
              disabled={!checkboxtotState.checkboxtot5||disabled[5]} 
              onChange={onChange}
              value={[inputValue1[5], inputValue2[5]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot5||disabled[5]} 
                min={inputValue1[5]}
                max={top[5]}
                step={stepG[5]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[5]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[5]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[5]>range[5]){
                    var auxiliares=inputValue1
                    auxiliares[5]=inputValue1[5]+stepG[5]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[5]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[5]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot5||!disabled[5]} 
                min={bottom[5]}
                max={top[5]}
                step={stepG[5]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[5]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[5]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[5]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[5]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[5]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[5]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[5]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[5]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[5]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[5]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot6'
                checked={checkboxtotState.checkboxtot6}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: speed</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot6||disabled[6]} 
                min={bottom[6]}
                max={inputValue2[6]}
                step={stepG[6]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[6]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[6]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[6]-newValue>range[6]){
                    var auxiliares=inputValue2
                    auxiliares[6]=inputValue2[6]-stepG[6]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[6], inputValue2[6]]} 
              step={stepG[6]}
              min={bottom[6]}
              max={top[6]}
              disabled={!checkboxtotState.checkboxtot6||disabled[6]} 
              onChange={onChange}
              value={[inputValue1[6], inputValue2[6]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot6||disabled[6]} 
                min={inputValue1[6]}
                max={top[6]}
                step={stepG[6]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[6]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[6]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[6]>range[6]){
                    var auxiliares=inputValue1
                    auxiliares[6]=inputValue1[6]+stepG[6]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[6]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[6]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot6||!disabled[6]} 
                min={bottom[6]}
                max={top[6]}
                step={stepG[6]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[6]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[6]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[6]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[6]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[6]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[6]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[6]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[6]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[6]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[6]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot7'
                checked={checkboxtotState.checkboxtot7}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: kmcost</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot7||disabled[7]} 
                min={bottom[7]}
                max={inputValue2[7]}
                step={stepG[7]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[7]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[7]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[7]-newValue>range[7]){
                    var auxiliares=inputValue2
                    auxiliares[7]=inputValue2[7]-stepG[7]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[7], inputValue2[7]]} 
              step={stepG[7]}
              min={bottom[7]}
              max={top[7]}
              disabled={!checkboxtotState.checkboxtot7||disabled[7]} 
              onChange={onChange}
              value={[inputValue1[7], inputValue2[7]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot7||disabled[7]} 
                min={inputValue1[7]}
                max={top[7]}
                step={stepG[7]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[7]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[7]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[7]>range[7]){
                    var auxiliares=inputValue1
                    auxiliares[7]=inputValue1[7]+stepG[7]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[7]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[7]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot7||!disabled[7]} 
                min={bottom[7]}
                max={top[7]}
                step={stepG[7]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[7]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[7]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[7]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[7]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[7]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[7]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[7]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[7]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[7]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[7]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot8'
                checked={checkboxtotState.checkboxtot8}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: hourcost</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot8||disabled[8]} 
                min={bottom[8]}
                max={inputValue2[8]}
                step={stepG[8]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[8]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[8]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[8]-newValue>range[8]){
                    var auxiliares=inputValue2
                    auxiliares[8]=inputValue2[8]-stepG[8]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[8], inputValue2[8]]} 
              step={stepG[8]}
              min={bottom[8]}
              max={top[8]}
              disabled={!checkboxtotState.checkboxtot8||disabled[8]} 
              onChange={onChange}
              value={[inputValue1[8], inputValue2[8]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot8||disabled[8]} 
                min={inputValue1[8]}
                max={top[8]}
                step={stepG[8]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[8]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[8]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[8]>range[8]){
                    var auxiliares=inputValue1
                    auxiliares[8]=inputValue1[8]+stepG[8]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[8]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[8]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot8||!disabled[8]} 
                min={bottom[8]}
                max={top[8]}
                step={stepG[8]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[8]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[8]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[8]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[8]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[8]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[8]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[8]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[8]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[8]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[8]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot9'
                checked={checkboxtotState.checkboxtot9}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: co2emissions</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot9||disabled[9]} 
                min={bottom[9]}
                max={inputValue2[9]}
                step={stepG[9]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[9]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[9]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[9]-newValue>range[9]){
                    var auxiliares=inputValue2
                    auxiliares[9]=inputValue2[9]-stepG[9]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[9], inputValue2[9]]} 
              step={stepG[9]}
              min={bottom[9]}
              max={top[9]}
              disabled={!checkboxtotState.checkboxtot9||disabled[9]} 
              onChange={onChange}
              value={[inputValue1[9], inputValue2[9]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot9||disabled[9]} 
                min={inputValue1[9]}
                max={top[9]}
                step={stepG[9]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[9]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[9]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[9]>range[9]){
                    var auxiliares=inputValue1
                    auxiliares[9]=inputValue1[9]+stepG[9]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[9]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[9]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot9||!disabled[9]} 
                min={bottom[9]}
                max={top[9]}
                step={stepG[9]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[9]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[9]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[9]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[9]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[9]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[9]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[9]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[9]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[9]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[9]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>
          <Divider style={{
            fontFamily:'report',
            fontSize:'18px',}}>FILTERING TRANSP DATA</Divider>
          <Row>
            <Checkbox 
                style={{marginRight: "10px" }}
                 value='checkboxtot10'
                checked={checkboxtotState.checkboxtot10}
                onChange={checkgeneral}>
            </Checkbox>
            <h1 style={{
            fontFamily:'report',
            fontSize:'22px',}}>Filter: num_vehicles</h1>
          </Row>
          <Row>
            <Col span={4}>
            <h6>Slider range filter</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot10||disabled[10]} 
                min={bottom[10]}
                max={inputValue2[10]}
                step={stepG[10]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue1[10]}
                onChange={(newValue) => {
                  var auxiliar=inputValue1
                  auxiliar[10]=newValue
                  setAux(!aux)
                  setInputValue1(auxiliar); 
                  if(inputValue2[10]-newValue>range[10]){
                    var auxiliares=inputValue2
                    auxiliares[10]=inputValue2[10]-stepG[10]
                    setInputValue2(auxiliares);
                  }
                }}
              />
            </Col>
            <div style={style}>
            <h6>&nbsp;</h6>
              <Slider 
              range defaultValue={[inputValue1[10], inputValue2[10]]} 
              step={stepG[10]}
              min={bottom[10]}
              max={top[10]}
              disabled={!checkboxtotState.checkboxtot10||disabled[10]} 
              onChange={onChange}
              value={[inputValue1[10], inputValue2[10]]}
              />

            </div>
            <Col span={4}>
            <h6>&nbsp;</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot10||disabled[10]} 
                min={inputValue1[10]}
                max={top[10]}
                step={stepG[10]}
                style={{
                  margin: '0 0px 0px 15px',
                }}
                value={inputValue2[10]}
                onChange={(newValue) => {
                  var auxiliar=inputValue2
                  auxiliar[10]=newValue
                  setAux(!aux)
                  setInputValue2(auxiliar);
                  if(newValue-inputValue1[10]>range[10]){
                    var auxiliares=inputValue1
                    auxiliares[10]=inputValue1[10]+stepG[10]
                    setInputValue1(auxiliares);
                  }
                }}
              />
            </Col>
           <Switch style={{marginTop:'25px',marginRight:'10px',marginLeft:'20px'}}  
           size="small" checked={disabled[10]} 
           onChange={(checked) => {
              var auxiliar=disabled
              auxiliar[10]=checked
              setAux(!aux)
              setDisabled(auxiliar);
            }} />
            <Col span={4}>
            <h6>Adder/Subtractor</h6>
              <InputNumber
              disabled={!checkboxtotState.checkboxtot10||!disabled[10]} 
                min={bottom[10]}
                max={top[10]}
                step={stepG[10]}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={inputValue3[10]}
                onChange={(newValue) => {
                  var auxiliar=inputValue3
                  auxiliar[10]=newValue
                  setAux(!aux)
                  setInputValue3(auxiliar)
                    
                }}
              />
            </Col>
            <h2 style={{marginTop: '10px'}}>&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;</h2>
          <Col span={4}>
          <h6>Top value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={top[10]}
                onChange={(value)=>{
                  var auxiliar=top
                  auxiliar[10]=value
                  setAux(!aux)
                  settop(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Bottom value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={bottom[10]}
                onChange={(value)=>{
                  var auxiliar=bottom
                  auxiliar[10]=value
                  setAux(!aux)
                  setbottom(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Step value</h6>
              <InputNumber
                min={-99}
                max={99}
                step={0.001}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={stepG[10]}
                onChange={(value)=>{
                  var auxiliar=stepG
                  auxiliar[10]=value
                  setAux(!aux)
                  setstepG(auxiliar)
                  }}
              />
            </Col>
            <Col span={4}>
          <h6>Max Range value</h6>
              <InputNumber
                min={-99999}
                max={99999}
                step={1}
                style={{
                  margin: '0px 0px 0px 0px',
                }}
                value={range[10]}
                onChange={(value)=>{
                  var auxiliar=range
                  auxiliar[10]=value
                  setAux(!aux)
                  setrange(auxiliar)
                  }}
              />
            </Col>
          </Row>

        <div className="divClass">
        <Button className="boton"
        style={{borderColor: "rgb(35,148,212)", 
        borderWidth:'2px',
        color:'rgb(0,104,178)',
        fontFamily:'report',
        fontSize:'18px',
        backgroundColor: "white" }}
            type="primary"
            onClick={() => {setPage(4)}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
          <Button className="boton"
          style={{borderColor: "rgb(35,148,212)", 
          borderWidth:'2px',
          color:'rgb(0,104,178)',
          fontFamily:'report',
          fontSize:'18px',
          backgroundColor: "white" }}
            type="primary"
            onClick={async () => {
              if(checkboxtotState.checkboxtot0||
                checkboxtotState.checkboxtot1||
                checkboxtotState.checkboxtot2||
                checkboxtotState.checkboxtot3||
                checkboxtotState.checkboxtot4||
                checkboxtotState.checkboxtot5||
                checkboxtotState.checkboxtot6||
                checkboxtotState.checkboxtot7||
                checkboxtotState.checkboxtot8||
                checkboxtotState.checkboxtot9||
                checkboxtotState.checkboxtot10){
                  setCircular(true)
                  await filtrar()
                  setCircular(false)
                }else{
                  notification["error"]({
                    message: `Select a filter to simulate it`,
                  });
                }
              }}>
            Save Changes
            <SaveOutlined />
          </Button>
        </div>
        {
        (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
        <div>
        </div>
        <div className="cargandos">
        </div>
        <div>
        </div>
      </div>
        :<div className="vacio">
          </div>
        }
      </div>
    );
  } else if (page===6){
    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Simulation: {name}</h2>
        <p></p>
        {/* <h1>Filtro de:</h1>
        <TreeSelect
            style={{
              width: '100%',
            }}
            value={value1}
            dropdownStyle={{
              maxHeight: 300,
              overflow: 'scroll ',
            }}
            treeData={treeData}
            placeholder="Please select"
            treeDefaultExpandAll
            onChange={onChangeFilter1}
          /> */}
          <Divider style={{
            fontFamily:'report',
            fontSize:'18px',}}>DEMAND</Divider>
            {/* fontSize:'18px',}}>OFFERING</Divider> */}
          <Row style={{justifyContent:'space-around',
          alignContent: 'center',
          height:'450px'}}>
            <Col>
              <h1 style={{
            fontFamily:'report',
            fontSize:'18px',}}>Axe: Distance</h1>
            {/* fontSize:'18px',}}>Axe: Geo-Distribution</h1> */}
            {/* fontSize:'18px',}}>Axe: Profitability</h1> */}
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                onChange={(newValue) => {
                  var auxiliar=value5
                  auxiliar[0]=newValue
                  setAux(!aux)
                  setValue5(auxiliar);
                }}
                value={value5[0]}
                />
              </div>
              <p>&nbsp;</p>
              <h1 style={{
            fontFamily:'report',
            fontSize:'18px',}}>Axe: Time</h1>
            {/* fontSize:'18px',}}>Axe: Systemic Viability</h1> */}
            {/* fontSize:'18px',}}>Axe: Productivity</h1> */}
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                onChange={(newValue) => {
                  var auxiliar=value5
                  auxiliar[1]=newValue
                  setAux(!aux)
                  setValue5(auxiliar);
                }}
                value={value5[1]}
                />
              </div>
              <p>&nbsp;</p>
              <h1 style={{
            fontFamily:'report',
            fontSize:'18px',}}>Axe: Emissions</h1>
            {/* fontSize:'18px',}}>Axe: Economic Nature</h1> */}
            {/* fontSize:'18px',}}>Axe: Systemic Viability</h1> */}
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                onChange={(newValue) => {
                  var auxiliar=value5
                  auxiliar[2]=newValue
                  setAux(!aux)
                  setValue5(auxiliar);
                }}
                value={value5[2]}
                />
              </div>
              <p>&nbsp;</p>
              <h1 style={{
            fontFamily:'report',
            fontSize:'18px',}}>Axe: % Orders Completed</h1>
            {/* fontSize:'18px',}}>Axe: Channel Capillarity</h1> */}
            {/* fontSize:'18px',}}>Axe: Safety</h1> */}
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                onChange={(newValue) => {
                  var auxiliar=value5
                  auxiliar[3]=newValue
                  setAux(!aux)
                  setValue5(auxiliar);
                }}
                value={value5[3]}
                />
              </div>
              <p>&nbsp;</p>
              <h1 style={{
            fontFamily:'report',
            fontSize:'18px',}}>Axe: Price</h1>
            {/* fontSize:'18px',}}>Axe: Operational Compatibility</h1> */}
            {/* fontSize:'18px',}}>Axe: Working Conditions </h1> */}
              <div style={style1}>
                <Slider 
                tooltip={(value) => `${value}%`}
                step={1}
                min={0}
                max={100}
                onChange={(newValue) => {
                  var auxiliar=value5
                  auxiliar[4]=newValue
                  setAux(!aux)
                  setValue5(auxiliar);
                }}
                value={value5[4]}
                />
              </div>
            </Col>
            <DemoPie data={data}>
            </DemoPie>
          </Row>

        <div className="divClass">
        <Button className="boton"
         style={{borderColor: "rgb(35,148,212)", 
         borderWidth:'2px',
         fontFamily:'report',
         fontSize:'18px',
         color:'rgb(0,104,178)',
         backgroundColor: "white" }}
            type="primary"
            onClick={() => {setPage(4)}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
          <Button className="boton"
           style={{borderColor: "rgb(35,148,212)", 
           borderWidth:'2px',
           fontFamily:'report',
           fontSize:'18px',
           color:'rgb(0,104,178)',
           backgroundColor: "white" }}
            type="primary"
            onClick={async () => {
              const datos = {    
                name:name,  
                distance: Math.round(100*(value5[0])/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                time: Math.round(100*value5[1]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                emissions: Math.round(100*value5[2]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                ord_complet: Math.round(100*value5[3]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                veh_filling: Math.round(100*value5[4]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
              }
              setCircular(true)
              await post(datos,'add-weights','add-weights','')
              setCircular(false)
            }}>
            Save Changes
            <SaveOutlined />
          </Button>
        </div>
        {
        (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
          <div></div>
          <div className="cargandos"></div>
          <div></div>
        </div>
        :<div className="vacio"></div>
        }
      </div>
    );
  } else if (page===7){

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>In development</h2>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            fontSize:'18px',
            backgroundColor: "white" }}
            onClick={() => {setPage(4)}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
      </div>
    );
  } else {

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>In development</h2>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            fontSize:'18px',
            backgroundColor: "white" }}
            onClick={() => {setPage(0)}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
      </div>
    );
  }
}

const treeData = [
  {
    title: 'IN1_Orders',
    value: '0-0',
    children: [
      {
        title: 'order_servicetime1',
        value: '0-0-1',
      },
      {
        title: 'order_servicetime2',
        value: '0-0-2',
      },
    ],
  },
  {
    title: 'IN2_Hubs',
    value: '0-1',
    children: [
      {
        title: 'hub_earlytime',
        value: '0-1-1',
      },
      {
        title: 'hub_latetime',
        value: '0-1-2',
      },
    ],
  },
  {
    title: 'IN3_TranspTypes',
    value: '0-2',
    children: [
      {
        title: 'transptype_capacityitems',
        value: '0-2-1',
      },
      {
        title: 'transptype_capacityweight',
        value: '0-2-2',
      },
      {
        title: 'transptype_speed',
        value: '0-2-3',
      },
    ],
  },
  {
    title: 'IN4_Transp',
    value: '0-3',
    children: [
      {
        title: 'transp_num',
        value: '0-3-1',
      },
    ]
  },
];


